import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-force-transport-dialog',
	standalone: true,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule],
	template: `<h2 class="text-center" mat-dialog-title>Uwaga!</h2>
		<mat-dialog-content class="text-center">
			<b>Transport jest niedostępny.</b><br />
			Jeśli klikniesz <b>„TAK”</b>, system spróbuje wymusić zmiany oraz wyśle powiadomienie na adres:
			<b>organizacja&#64;oskar.com.pl</b>
			<br />
			Czy mimo to chcesz kontynuować?
		</mat-dialog-content>
		<mat-dialog-actions align="end"
			><button (click)="onConfirm()" color="primary" mat-raised-button>Tak</button
			><button (click)="onCancel()" color="warn" mat-raised-button>Nie</button></mat-dialog-actions
		>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForceTransportDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<ForceTransportDialogComponent>);

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}
}
